import React from 'react';

import { cidadeNormal08 } from '../components/HeroBusiness/Data';

import HeaderMenu from '../components/HeaderMenu';
import HeroBusiness from '../components/HeroBusiness';
import Footer from '../components/Footer';


const CidadeNormal08 = () => {
  return (
    <>
    <HeaderMenu />
    <HeroBusiness {...cidadeNormal08}/>
    <Footer />
      
    </>
  )
}

export default CidadeNormal08
